import React, { Component } from 'react';

import Substitute from './Substitute';
import EventType from './EventType';

class Events extends Component {
  render() {
    const events = [];
    const { data, teams } = this.props;

    // Is not array?
		if( typeof data.event.length !== 'number' ) {
      data.event = [data.event];
    }

    // Reverse if its live
    data.event = this.props.isLive ? data.event.reverse() : data.event;

		for( let j = 0; j < data.event.length; j++ ) {
      if( data.event[j].type === 'out' ) continue;
      // IF ITS A SUBTIBUTE USE ANOTHER NOTATION
      if( data.event[j].type === 'inout' ){
        events.push(
          <tr key={j}>
            <Substitute place={1} event={data.event[j]} />
            <td width="10%" className="min">{data.event[j].minute}'</td>
            <Substitute place={2} event={data.event[j]} />
          </tr>
        )
      }else{
        events.push(
          <tr key={j}>
            <td width="10%">{data.event[j].team === '1' ? <EventType type={data.event[j].type} /> : ''}</td>
            <td  width="32.5%" className="player1">{data.event[j].team === '1' ? (data.event[j].player === '' ? <span></span> : data.event[j].player) : ''}</td>
            <td width="15%" className="min">{data.event[j].minute}'</td>
            <td  width="32.5%" className="player2">{data.event[j].team === '2' ? (data.event[j].player === '' ? <span></span> : data.event[j].player) : ''}</td>
            <td width="10%">{data.event[j].team === '2' ? <EventType type={data.event[j].type} /> : ''}</td>
          </tr>
        )
      }
		}

    // caclulate cetner panel
    let centerPanel;

    if (this.props.isLive) {
      // live panel
      centerPanel = (
        <div>
          <div className="score">
            {this.props.score.goal1} - {this.props.score.goal2}
          </div>
          {!this.props.isHT &&
            <div className="min">
               {this.props.min}
            </div>}
          {this.props.isHT &&
            <span>HM</span>}
        </div>
      );
    } else {
      // show score info
      centerPanel = (
        <div>
          <div className="score">
            {this.props.score.goal1} - {this.props.score.goal2}
          </div>
          <div className="halfscore">
            ( {this.props.score.ht_goal1} - {this.props.score.ht_goal2} )
          </div>
        </div>
      );
    }

    return (
      <div className="events_container">
        <table>
          <tbody>
            <tr className="header">
              <td colSpan="2" className="team1">{teams.hometeam.name}</td>
              <td>{centerPanel}</td>
              <td colSpan="2" className="team2">{teams.awayteam.name}</td>
            </tr>
            {events}
          </tbody>
        </table>
      </div>
    )
  }
};

export default Events;


// WEBPACK FOOTER //
// ./src/Components/Events.js